import API from "../api/axios";

// ─── Get Reports ───
export const getReports = (type) => {
   return API.get(`/reports?type=${type}`);
};

// ─── Export Reports ───
export const exportReports = (type) => {
   return API.get(`/reports/export?type=${type}`, { responseType: "blob" });
};